/**
 * Formatta una data nel formato "Tue, 25 Jun" (giorno abbreviato, data, mese abbreviato)
 * Se includeYear è true, aggiunge l'anno: "Tue, 25 Jun 2024"
 */
export const formatShortDate = (date: Date, includeYear: boolean = false): string => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const day = days[date.getDay()];
    const dayNum = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    
    if (includeYear) {
        return `${day}, ${dayNum} ${month} ${year}`;
    }
    return `${day}, ${dayNum} ${month}`;
};

/**
 * Formatta un timestamp relativo (es. "5h ago", "2d ago", "30m ago")
 */
export const formatRelativeTime = (date: Date): string => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) {
        return 'just now';
    } else if (diffMins < 60) {
        return `${diffMins}m ago`;
    } else if (diffHours < 24) {
        return `${diffHours}h ago`;
    } else if (diffDays < 7) {
        return `${diffDays}d ago`;
    } else {
        return formatShortDate(date);
    }
};

